// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    defaultMessage: 'Načítavajú sa údaje kasy',
    id: 'auth.form.loading'
  },
});
